'use strict';

var RejectModalController = function RejectModalController($scope, pendingUserRequestService, userManagementConstants) {
  $scope.rejectUser = function () {
    var status = false;
    var message = $scope.rejectMessage;
    if ($scope.rejectMessage === undefined) {
      message = 'Your request has been denied.';
    }
    pendingUserRequestService.sendConfirmEmail(status, $scope.user, message);
    pendingUserRequestService.rejectUser($scope.user.userId).then(function () {
      if ($scope.pendingNumbers === 1) {
        $scope.$emit('user-management-manage-users:change-screen', userManagementConstants.SCREEN_VALUE.MANAGE_USERS);
      } else {
        $scope.$emit('user-management-manage-users:change-screen', userManagementConstants.MANAGE_USERS_SCREENS.MANAGE_ACCESS_REQUESTS);
      }
      $scope.hideRejectModal();
    });
  };
};
RejectModalController.$inject = ['$scope', 'PendingUserRequestService', 'UserManagementConstants'];
module.exports = RejectModalController;